import z from 'zod';

import DeviationEnum from '../interfaces/deviation';

export const DeviationDtoScheme = z.object({
	type: z.nativeEnum(DeviationEnum).describe(''),
	description: z.string().describe(''),
	order: z.number().describe(''),
	criticality: z.enum(['error', 'warning', 'acceptable_error']),
});

export type DeviationDto = z.infer<typeof DeviationDtoScheme>;
